module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "bharathi.60c077cd.jpg";